import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ViewTopicWrapper = styled.div`
  .accordion-header:not(:first-of-type) {
    margin-top: 24px;

    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_PORTRAIT`
        &:nth-child(1), &:nth-child(2) {
          margin-top: 0px;
        }
        &:nth-child(n+3) {
          margin-top: 40px;
        }
      `}
    ${responsive.MOBILE`
        &:nth-child(1) {
          margin-top: 0px;
        }
        &:nth-child(n+2) {
          margin-top: 16px;
        }
      `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }

  .selected-preferences {
    margin-top: 40px;

    h3 {
      color: ${COLORS.cirrus_black10};
      line-height: 19px;
    }
  }

  .preferences-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
    row-gap: 8px;
    column-gap: 16px;

    .preferences-chip {
      padding: 0;
    }
  }

  .topic-details-container,
  .exception-container,
  .locale-container {
    padding: 24px 16px;

    ${responsive.MOBILE`
      padding: 16px;
    `}
  }

  .cell-country {
    width: 40%;
  }

  .cell-measurement {
    min-width: 200px;
  }
`;
